import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPlan = function SvgPlan(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M21 0a3 3 0 00-3 3c.002.789.317 1.544.876 2.1a.25.25 0 01.05.279l-2.7 5.979a.25.25 0 01-.233.147 2.9 2.9 0 00-1.945.726.25.25 0 01-.276.035l-2.65-1.327a.25.25 0 01-.139-.244A2.993 2.993 0 105.8 12.531c.07.076.086.188.04.281l-2.512 5.063a.25.25 0 01-.235.139 2.993 2.993 0 102.107.954.251.251 0 01-.04-.281l2.513-5.064a.25.25 0 01.234-.139 2.9 2.9 0 002.05-.716.25.25 0 01.274-.035l2.652 1.326a.25.25 0 01.138.244 2.993 2.993 0 105.98.2 2.969 2.969 0 00-.876-2.1.251.251 0 01-.05-.28l2.7-5.983a.252.252 0 01.23-.147A2.996 2.996 0 1021 0z"
  }));
};

export default SvgPlan;